<span (click)="onClick()" *ngIf="!open" class="closed">
  <ng-content></ng-content>
</span>

<span *ngIf="open" class="open">
  <span class="confirm-text" translate="SHARED.CONFIRM.TEXT"></span>
  <button mat-raised-button (click)="doConfirm()" [color]="yescolor">
    <span translate="SHARED.CONFIRM.YES"></span>
  </button>
  <button mat-raised-button (click)="cancelConfirm()">
    <span translate="SHARED.CONFIRM.NO"></span>
  </button>
</span>
